<template>
  <div class="item" v-for="item in items" :key="item.id">
    <img class="item__img" :src="getImageTeamPath(item.id)" alt="icon" />
    <div class="description-block" @click="openVacancy(item.id)">
      <p>{{ item.title }}</p>
      <img src="@/assets/images/icons/arrow-black.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "popular-vacancy-item",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openVacancy(id) {
      this.$router.push(`/vacancy/${id}`);
    },
    getImageTeamPath(item) {
      return require(`@/assets/images/popular-vacancy/${item}.jpeg`);
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid #1c1c1c;
  width: 440px;
  box-sizing: border-box;
  overflow: hidden;
  &:nth-child(4),
  &:nth-child(5) {
    .item__img {
      width: 505px !important;
      object-position: left;
    }
  }

  @media (max-width: 767px) {
    width: 350px;
  }

  &__img {
    max-height: 475px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: right;

    @media (max-width: 767px) {
      max-height: 344px;
    }
  }

  &:last-child {
    .item__img {
      object-position: bottom;
    }
  }

  .description-block {
    border-top: 1px solid #1c1c1c;
    display: flex;
    height: 106px;
    align-items: baseline;
    justify-content: space-between;
    margin-top: -4px;

    @media (max-width: 767px) {
      height: 85px;
    }

    p {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 20px;
      padding-top: 16px;
      font-family: "UAF Sans HR", serif;
      font-weight: 400;
      font-size: 18px;
      line-height: 22px;
      text-transform: uppercase;
      position: relative;
      max-width: 300px;
      transition: 0.3s;

      @media (max-width: 767px) {
        font-size: 14px;
        line-height: 18px;
      }

      //&:after {
      //  content: "";
      //  position: absolute;
      //  right: 0;
      //  top: calc(100% - 18px);
      //  width: 1px;
      //  height: 106px;
      //  background: #1c1c1c;
      //}
    }

    img {
      border-left: 1px solid #1c1c1c;
      width: 20px;
      align-self: center;
      padding: 40px;
      margin-top: -5px;
      transition: 0.3s;

      @media (max-width: 767px) {
        padding: 35px;
        margin-top: 0;
      }
    }
    &:hover {
      p {
        font-family: "UAF Sans H", serif;
        transition: 0.3s;
      }
      img {
        width: 40px;
        padding: 30px;
        transition: 0.3s;
      }
    }
  }
}
</style>
